import { NError, NSuccess } from '@configs/const.config'
import { TResApi, TResApiErr, TResDataListApi } from '@configs/interface.config'
import { checkAuth } from '@libs/localStorage'
import { TEmployee, TPatchEmployee, TQueryEmployee } from '@src/modules'
import { notification } from 'antd'
import { useMutation, useQuery } from 'react-query'

import {
  getEmployeeById,
  getListEmployee,
  patchEmployeeById,
  postEmployee,
  removeEmployeeById,
} from '../apis'
import { DETAIL_EMPLOYEE, LIST_EMPLOYEE } from '../keys'

export const useQueryListEmployee = (params: TQueryEmployee, token?: string) => {
  const accessToken = token || checkAuth()
  return useQuery<TResDataListApi<TEmployee[]>>(
    [LIST_EMPLOYEE, JSON.stringify(params)],
    () => getListEmployee(params, accessToken),
    { enabled: !!accessToken },
  )
}

export const useQueryEmployeeById = (id: number, token?: string) => {
  const accessToken = token || checkAuth()
  return useQuery<TResApi<TEmployee>>(
    [DETAIL_EMPLOYEE, id],
    () => getEmployeeById(id, accessToken),
    { enabled: !!accessToken && !!id },
  )
}

export const useMutationPostEmployee = () =>
  useMutation(postEmployee, {
    onSuccess: (res: TResApi<TEmployee>) => {
      notification.success({ message: NSuccess, description: res?.message })
    },
    onError: (error: TResApiErr) => {
      notification.error({ message: NError, description: error?.message })
    },
  })

export const useMutationPatchEmployeeById = () =>
  useMutation(
    ({ id, data }: { id: number; data: TPatchEmployee }) => patchEmployeeById(id, data),
    {
      onSuccess: (res: TResApi) => {
        notification.success({ message: NSuccess, description: res?.message })
      },
      onError: (error: TResApiErr) => {
        notification.error({ message: NError, description: error?.message })
      },
    },
  )

export const useMutationRemoveEmployeeById = () =>
  useMutation(removeEmployeeById, {
    onSuccess: (res: TResApi) => {
      notification.success({ message: NSuccess, description: res?.message })
    },
    onError: (error: TResApiErr) => {
      notification.error({ message: NError, description: error?.message })
    },
  })
